import React, { Component } from 'react';
import { findDOMNode } from 'react-dom';

import Tooltip from './tooltip';

const isTextOverflow = element => element.clientWidth < element.scrollWidth;

export default class OverflowTooltip extends Component {
    static defaultProps = {
        children: null
    }

    state = {
        overflow: false,
        text: null
    }

    handleTooltipShow = () => {
        this.checkOverflow();
    }

    getText() {
        if (!this.props.children) {
            return '';
        }

        return findDOMNode(this).textContent;
    }

    updateText() {
        const text = this.getText();

        if (text !== this.state.text) {
            this.setState({ text });
        }
    }

    checkOverflow() {
        if (!this.props.children) {
            return false;
        }

        const element = findDOMNode(this);
        const overflow = isTextOverflow(element);

        if (overflow !== this.state.overflow) {
            this.setState({ overflow });
        }

        return overflow;
    }

    componentDidMount() {
        if (this.checkOverflow()) {
            this.updateText();
        }
    }

    componentDidUpdate() {
        if (this.checkOverflow()) {
            this.updateText();
        }
    }

    render() {
        if (this.state.overflow) {
            return (
                <Tooltip
                    tooltip={this.state.text}
                    placement={this.props.placement}
                    onShow={this.handleTooltipShow}
                >
                    { this.props.children }
                </Tooltip>
            )
        }

        return this.props.children;
    }
}
